import React from 'react';
import { Tag } from 'core/components';
import { isPastDate } from 'core/util/dateUtils';

const LABELS = {
  updated: { label: 'Updated', className: 'updated', intent: 'warning' },
  beta: { label: 'Beta', className: 'beta', intent: 'success' },
  new: { label: 'New', className: 'new', intent: 'warning' },
  preview: { label: 'Preview', className: 'preview', intent: 'success' },
  ea: { label: 'EA', className: 'ea', intent: 'warning' }
} as const;

type ProductLabelKey = keyof typeof LABELS;

interface ProductLabelProps {
  label: ProductLabelKey;
  expiryDate?: string;
}

const ProductLabel = ({ label, expiryDate, ...rest }: ProductLabelProps) => {
  if (expiryDate && isPastDate(expiryDate)) {
    return null;
  }

  const match = LABELS[label];

  if (!match) {
    return null;
  }

  return (
    <>
      {' '}
      <Tag className={`product-meta ${match.className}`} intent={match.intent} {...rest}>
        {match.label}
      </Tag>
    </>
  );
};

export default ProductLabel;
